<div class="d-flex justify-content-center">
    <!-- <span *ngIf="isLogin" id="googleSignIn">{{ 'login.refresh' | translate }}</span>
    <span *ngIf="!isLogin" id="googleSignUp">{{ 'login.refresh' | translate }}</span> -->
    <span id="googleButton">{{ 'login.refresh' | translate }}</span>
</div>